export const confidenceIndicatorColor = conf => {
  if (!conf) return null;
  if (conf === "90%") return "red";
  if (conf === "95%") return "#ffa31a"; // orange
  if (conf === "99%") return "green";
  return null;
};
